<div id="login" fxLayout="column" fxFlex>
    <div id="login-form-wrapper" fxLayout="column" fxLayoutAlign="center center">
        @if (!showRemember) {
            <div id="login-form" [@animate]="{ value: '*', params: { duration: '800ms', y: '500px' } }">
                <div class="logo">
                    @if (entryPointResources !== "") {
                        <img [src]="imageSvc.getLogo()" />
                    }
                    @if (entryPointResources === "") {
                        <img src="assets/images/logos/logo.png" />
                    }
                </div>
                @if (canLogin()) {
                    <form name="loginForm" [formGroup]="loginForm" (ngSubmit)="onLogin()" novalidate>
                        <mat-form-field appearance="outline">
                            <mat-label>{{ "login.username" | translate }}</mat-label>
                            <input matInput formControlName="usuario" autocomplete="off" />
                            <mat-icon matSuffix class="secondary-text">person_outline</mat-icon>
                            @if (loginForm.get("usuario").hasError("required")) {
                                <mat-error>
                                    {{ "login.error.username" | translate }}
                                </mat-error>
                            }
                        </mat-form-field>
                        <mat-form-field appearance="outline">
                            <mat-label>{{ "login.password" | translate }}</mat-label>
                            <input matInput type="password" formControlName="password" autocomplete="off" />
                            <mat-icon matSuffix class="secondary-text">lock</mat-icon>
                            <mat-error>
                                {{ "login.error.password" | translate }}
                            </mat-error>
                        </mat-form-field>
                        <button
                            mat-raised-button
                            color="accent"
                            class="submit-button w-100-p"
                            aria-label="Iniciar sesión"
                        >
                            <!-- [disabled]="loginForm.invalid"> -->
                            {{ "login.login" | translate }}
                        </button>
                    </form>
                }
                <div class="separator">
                    <span class="text">O</span>
                </div>
                @if (canLoginGoogle()) {
                    <button mat-raised-button class="google w-100-p" (click)="loginGoogle()">
                        {{ "login.google" | translate }}
                    </button>
                }
                @if (canLoginOutlook()) {
                    <button mat-raised-button class="outlook w-100-p" (click)="loginOutlook()">
                        {{ "login.outlook" | translate }}
                    </button>
                }
                @if (canRememberPassword()) {
                    <div
                        class="remember-forgot-password mb-4"
                        fxLayout="row"
                        fxLayout.xs="column"
                        fxLayoutAlign="center center"
                    >
                        <a class="forgot-password" (click)="showRemember = true">
                            {{ "login.forgot.pass" | translate }}
                        </a>
                    </div>
                }
                <div fxLayout="row" fxLayoutAlign="center center" class="h-10" style="position: relative">
                    @if (msgErrorLogin && msgErrorLogin !== "") {
                        <mat-error style="position: absolute; top: 2px">{{ msgErrorLogin }}</mat-error>
                    }
                </div>
            </div>
        }

        @if (showRemember) {
            <div id="remember-form" [@animate]="{ value: '*', params: { duration: '800ms', y: '500px' } }">
                <div class="logo">
                    @if (entryPointUrl !== "") {
                        <img [src]="imageSvc.getLogo()" />
                    }
                    @if (entryPointUrl === "") {
                        <img src="assets/images/logos/logo.png" />
                    }
                </div>
                <h5 class="text">{{ "login.forgot.pass.help2" | translate }}</h5>
                <form name="rememberForm" [formGroup]="rememberForm" (ngSubmit)="onRemember()" novalidate>
                    <mat-form-field appearance="outline">
                        <mat-label>{{ "person_edit.email" | translate }}</mat-label>
                        <input matInput formControlName="emailRemember" />
                        <mat-icon matSuffix class="secondary-text">person_outline</mat-icon>
                        @if (loginForm.get("usuario").hasError("required")) {
                            <mat-error>
                                {{ "login.error.username" | translate }}
                            </mat-error>
                        }
                    </mat-form-field>
                    <button mat-raised-button color="accent" class="submit-button w-100-p" aria-label="Enviar">
                        {{ "general.button.send" | translate }}
                    </button>
                    <div
                        class="remember-forgot-password mb-4"
                        fxLayout="row"
                        fxLayout.xs="column"
                        fxLayoutAlign="center center"
                    >
                        <a class="forgot-password" (click)="showRemember = false">
                            {{ "general.button.cancel" | translate }}
                        </a>
                    </div>
                </form>
                <div fxLayout="row" fxLayoutAlign="center center" class="h-10" style="position: relative">
                    @if (msgErrorRemember && msgErrorRemember !== "") {
                        <mat-error style="position: absolute; top: 2px">{{ msgErrorRemember }}</mat-error>
                    }
                </div>
            </div>
        }

        @if (msgSuccessRemember && msgSuccessRemember !== "") {
            <div
                fxLayout="row"
                fxLayoutAlign="center center"
                class="h-10"
                style="width: 100%"
                [@animate]="{ value: '*', params: { duration: '800ms', y: '500px' } }"
            >
                <span style="position: absolute; top: 14px; color: green">{{ msgSuccessRemember }}</span>
            </div>
        }
    </div>
</div>
